export default [
  {
    name: 'Tour Historico',
    path: 'tour',
    component: () => import('@/views/tour/Historico.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [{ name: 'Administração', path: '/administracao' }, { name: 'Tour' }]
    }
  }
];
